<template>
  <div>
    <div>
      <el-tabs v-model="activeName" type="card" class="tabs-one" style="padding-top: 20px;">
        <el-tab-pane name="1" class="active">
          <span slot="label"><i class="el-icon"></i>私募</span>
          <privateSales></privateSales>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label"><i class="el-icon"></i>公募</span>
          <publicSales></publicSales>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
import privateSales from "./privateSales.vue";
import publicSales from "./publicSales.vue";

export default {
  components: {
    privateSales,
    publicSales,
  },
  data () {
    return {
      activeName: '1',
    }
  },
  created () {
    this.activeName = this.$route.params.active ? this.$route.params.active : '1'
  },
}
</script>

<style lang="less" scoped>
</style>